const ms = typeof window !== "undefined" && window.multipleSelect !== void 0 ? window.multipleSelect : { locales: {} };
export const English = {
  formatFilterPlaceholder() {
    return "Type a text to filter the list";
  },
  formatSelectAll() {
    return "[Select all]";
  },
  formatAllSelected() {
    return "All selected";
  },
  formatCountSelected(count, total) {
    return `${count} of ${total} selected`;
  },
  formatNoMatchesFound() {
    return "No matches found";
  },
  formatOkButton() {
    return "OK";
  }
};
ms.locales["en"] = English;
export default ms.locales;
